import React from "react"

// TODO: need to add mobile option
export const Title: React.FunctionComponent = ({ children }) => {
  return (
    <div className="image-list-view-item-title" data-tam="image-list-view-item-title">
      {children}
    </div>
  )
}
